/*
  Emper Scent Finder (sections/scent-finder.liquid).
  Engine: the note -> accord knowledge, free-text reading and scoring of the Stallion 53 scent finder,
  extended for the Emper catalogue (Arabian notes, gourmands, florals; whole-word matching for short notes).
  Interface: reads the live catalogue (products.json), runs the quiz, ranks, renders the matches and
  adds to cart through the theme's own product-form, so the cart drawer opens as everywhere else.
*/
  /* ---------- Scent engine: note knowledge + matching (from the Stallion 53 scent finder, extended for the Emper catalogue) ---------- */
  var ScentEngine = (function () {
    var FACETS = ['citrus', 'fresh', 'green', 'fruity', 'floral', 'spicy', 'sweet', 'woody', 'amber', 'musk', 'leather'];

    // Note knowledge base. First keyword found inside a note name wins, so specific entries come first.
    // [keyword, canonical name, accords]
    var NOTES = [
      // ---- Emper catalogue notes (Arabian perfumery, gourmands, florals), ahead of the generic entries ----
      ['passionflower', 'Passionflower', { floral: 0.8, fruity: 0.3 }],
      ['night blooming cereus', 'Night-Blooming Cereus', { floral: 0.9, sweet: 0.3 }],
      ['beach flower', 'Beach Flower', { floral: 0.6, fresh: 0.6 }],
      ['sweet pea', 'Sweet Pea', { floral: 0.9, fresh: 0.3, sweet: 0.2 }],
      ['hyacinth', 'Hyacinth', { floral: 0.9, green: 0.4 }],
      ['champaca', 'Champaca', { floral: 1, fruity: 0.2 }],
      ['datura', 'Datura', { floral: 0.9, sweet: 0.2 }],
      ['mahoni', 'Mahonial', { floral: 0.8, fresh: 0.4 }],
      ['cedrat', 'Citron', { citrus: 1, fresh: 0.3 }],
      ['blackberr', 'Blackberry', { fruity: 1, sweet: 0.3 }],
      ['dates', 'Dates', { sweet: 0.8, fruity: 0.4, amber: 0.3 }],
      ['cotton candy', 'Cotton Candy', { sweet: 1, fruity: 0.2 }],
      ['panna cotta', 'Panna Cotta', { sweet: 0.9, musk: 0.3 }],
      ['brandy', 'Brandy', { amber: 0.7, sweet: 0.6 }],
      ['whisk', 'Whiskey', { amber: 0.7, sweet: 0.4, woody: 0.4 }],
      ['myrrh', 'Myrrh', { amber: 0.9, spicy: 0.3, leather: 0.2 }],
      ['tolu', 'Tolu Balsam', { amber: 0.9, sweet: 0.5 }],
      ['mastic', 'Mastic', { amber: 0.6, green: 0.5, fresh: 0.2 }],
      ['iso e super', 'Iso E Super', { woody: 0.9, musk: 0.4 }],
      ['aloe', 'Aloe Vera', { fresh: 0.8, green: 0.6 }],
      ['mate', 'Maté', { green: 0.8, fresh: 0.3 }],
      ['agarwood', 'Oud', { woody: 0.9, leather: 0.6, amber: 0.5 }],
      ['oud', 'Oud', { woody: 0.9, leather: 0.6, amber: 0.5 }],
      ['olibanum', 'Frankincense', { amber: 0.9, leather: 0.4, spicy: 0.3 }],
      ['frankincense', 'Frankincense', { amber: 0.9, leather: 0.4, spicy: 0.3 }],
      ['opopanax', 'Opopanax', { amber: 0.9, sweet: 0.4 }],
      ['bakhoor', 'Bakhoor', { amber: 0.9, woody: 0.7, leather: 0.4 }],
      ['tobacco', 'Tobacco', { amber: 0.7, sweet: 0.5, woody: 0.4 }],
      ['immortelle', 'Immortelle', { sweet: 0.6, amber: 0.6, spicy: 0.3 }],
      ['cherry blossom', 'Cherry Blossom', { floral: 0.8, fruity: 0.3 }],
      ['almond blossom', 'Almond Blossom', { floral: 0.7, sweet: 0.4 }],
      ['cactus flower', 'Cactus Flower', { floral: 0.6, green: 0.5 }],
      ['coconut', 'Coconut', { sweet: 0.8, fruity: 0.3, musk: 0.3 }],
      ['raspberr', 'Raspberry', { fruity: 1, sweet: 0.3 }],
      ['blueberr', 'Blueberry', { fruity: 1, sweet: 0.2 }],
      ['cranberr', 'Cranberry', { fruity: 1, citrus: 0.2 }],
      ['wild berr', 'Red Berries', { fruity: 1, sweet: 0.3 }],
      ['currant', 'Blackcurrant', { fruity: 1 }],
      ['cassis', 'Blackcurrant', { fruity: 1 }],
      ['cherry', 'Cherry', { fruity: 0.9, sweet: 0.4 }],
      ['plum', 'Plum', { fruity: 0.8, sweet: 0.4, amber: 0.2 }],
      ['apricot', 'Apricot', { fruity: 1, sweet: 0.2 }],
      ['nectarine', 'Nectarine', { fruity: 1 }],
      ['melon', 'Melon', { fruity: 0.8, fresh: 0.5 }],
      ['papaya', 'Papaya', { fruity: 1, sweet: 0.2 }],
      ['pomegranate', 'Pomegranate', { fruity: 1 }],
      ['litchi', 'Lychee', { fruity: 1 }],
      ['fig', 'Fig', { fruity: 0.6, green: 0.5, woody: 0.2 }],
      ['rhubarb', 'Rhubarb', { fruity: 0.6, green: 0.5, citrus: 0.3 }],
      ['cucumber', 'Cucumber', { fresh: 0.9, green: 0.6 }],
      ['davana', 'Davana', { fruity: 0.6, sweet: 0.4, green: 0.3 }],
      ['yuzu', 'Yuzu', { citrus: 1, fresh: 0.3 }],
      ['tangerine', 'Tangerine', { citrus: 1, fruity: 0.3 }],
      ['citron', 'Citron', { citrus: 1 }],
      ['lime', 'Lime', { citrus: 1, fresh: 0.4 }],
      ['gardenia', 'Gardenia', { floral: 1, sweet: 0.2 }],
      ['freesia', 'Freesia', { floral: 0.9, fresh: 0.3 }],
      ['heliotrope', 'Heliotrope', { floral: 0.6, sweet: 0.6, musk: 0.4 }],
      ['ylang', 'Ylang-Ylang', { floral: 1, sweet: 0.2 }],
      ['magnolia', 'Magnolia', { floral: 1, citrus: 0.2 }],
      ['cyclamen', 'Cyclamen', { floral: 0.8, fresh: 0.4 }],
      ['honeysuckle', 'Honeysuckle', { floral: 1, sweet: 0.3 }],
      ['lotus', 'Lotus', { floral: 0.7, fresh: 0.5 }],
      ['tiare', 'Tiare Flower', { floral: 1, sweet: 0.3 }],
      ['frangipani', 'Frangipani', { floral: 1, sweet: 0.3 }],
      ['camellia', 'Camellia', { floral: 0.9 }],
      ['camelia', 'Camellia', { floral: 0.9 }],
      ['carnation', 'Carnation', { floral: 0.8, spicy: 0.5 }],
      ['linden', 'Linden Blossom', { floral: 0.8, green: 0.3 }],
      ['narcissus', 'Narcissus', { floral: 0.9, green: 0.3 }],
      ['daffodil', 'Narcissus', { floral: 0.9, green: 0.3 }],
      ['bluebell', 'Bluebell', { floral: 0.9, green: 0.3 }],
      ['rangoon', 'Rangoon Creeper', { floral: 1 }],
      ['white flower', 'White Flowers', { floral: 1 }],
      ['honey', 'Honey', { sweet: 1, amber: 0.4 }],
      ['marshmallow', 'Marshmallow', { sweet: 1, musk: 0.3 }],
      ['ethyl maltol', 'Caramelised Sugar', { sweet: 1 }],
      ['hazelnut', 'Hazelnut', { sweet: 0.8, woody: 0.3 }],
      ['chestnut', 'Chestnut', { sweet: 0.8, woody: 0.3 }],
      ['pistachio', 'Pistachio', { sweet: 0.8, green: 0.2 }],
      ['bitter almond', 'Almond', { sweet: 0.8, amber: 0.2 }],
      ['almond', 'Almond', { sweet: 0.8, amber: 0.2 }],
      ['coumarin', 'Coumarin', { sweet: 0.7, amber: 0.4, green: 0.2 }],
      ['onka', 'Tonka Bean', { sweet: 0.8, amber: 0.5 }],
      ['cacao', 'Cocoa', { sweet: 0.9, amber: 0.3 }],
      ['chocolate', 'Chocolate', { sweet: 1, amber: 0.3 }],
      ['licorice', 'Licorice', { spicy: 0.6, sweet: 0.5 }],
      ['anise', 'Anise', { spicy: 0.6, sweet: 0.5 }],
      ['clove', 'Clove', { spicy: 1 }],
      ['cassia', 'Cassia', { spicy: 0.9, sweet: 0.3 }],
      ['pimento', 'Pimento', { spicy: 1 }],
      ['coriander', 'Coriander', { spicy: 0.7, green: 0.4 }],
      ['caraway', 'Caraway', { spicy: 0.7, green: 0.3 }],
      ['bay leaf', 'Bay Leaf', { green: 0.6, spicy: 0.4 }],
      ['basil', 'Basil', { green: 1, fresh: 0.2 }],
      ['thyme', 'Thyme', { green: 1, spicy: 0.2 }],
      ['artemisia', 'Artemisia', { green: 0.9 }],
      ['juniper', 'Juniper', { green: 0.7, fresh: 0.5 }],
      ['eucalyptus', 'Eucalyptus', { fresh: 0.8, green: 0.8 }],
      ['galbanum', 'Galbanum', { green: 1 }],
      ['rum', 'Rum', { sweet: 0.6, amber: 0.5 }],
      ['champagne', 'Champagne', { fruity: 0.5, fresh: 0.5 }],
      ['gin', 'Gin Accord', { fresh: 0.6, green: 0.5 }],
      ['mineral', 'Mineral Accord', { fresh: 0.9 }],
      ['ozon', 'Ozonic Accord', { fresh: 1 }],
      ['aquatic', 'Aquatic Accord', { fresh: 1 }],
      ['aldehyd', 'Aldehydes', { fresh: 0.8, musk: 0.5 }],
      ['warm sand', 'Warm Sand', { amber: 0.6, musk: 0.5 }],
      ['amyris', 'Amyris', { woody: 0.8 }],
      ['evernyl', 'Oakmoss', { woody: 0.7, green: 0.6 }],
      ['ambrox', 'Ambroxan', { amber: 0.8, musk: 0.4, fresh: 0.2 }],
      ['gourmand', 'Gourmand Accord', { sweet: 1, amber: 0.3 }],
      ['tamarind', 'Tamarind', { fruity: 0.6, sweet: 0.4, spicy: 0.2 }],
      ['cypress', 'Cypress', { woody: 0.8, green: 0.5 }],
      ['orange blossom', 'Orange Blossom', { floral: 1, citrus: 0.3 }],
      ['neroli', 'Neroli', { floral: 0.8, citrus: 0.5 }],
      ['violet leaf', 'Violet Leaf', { green: 0.9, fresh: 0.4 }],
      ['green tea', 'Green Tea', { green: 1, fresh: 0.4 }],
      ['lapsang', 'Smoked Tea', { leather: 0.8, green: 0.5 }],
      ['tea', 'Tea', { green: 0.9, fresh: 0.3 }],
      ['green apple', 'Green Apple', { fruity: 0.9, green: 0.4, fresh: 0.3 }],
      ['passion fruit', 'Passion Fruit', { fruity: 1 }],
      ['dragon fruit', 'Dragon Fruit', { fruity: 1 }],
      ['red berries', 'Red Berries', { fruity: 1, sweet: 0.3 }],
      ['pink pepper', 'Pink Pepper', { spicy: 0.9, fresh: 0.2 }],
      ['black pepper', 'Black Pepper', { spicy: 1 }],
      ['pepper', 'Pepper', { spicy: 1 }],
      ['brown sugar', 'Brown Sugar', { sweet: 1 }],
      ['cocoa', 'Cocoa', { sweet: 0.9, amber: 0.3 }],
      ['coffee', 'Coffee', { sweet: 0.7, leather: 0.4, amber: 0.3 }],
      ['cognac', 'Cognac', { amber: 0.7, sweet: 0.6 }],
      ['caramel', 'Caramel', { sweet: 1 }],
      ['praline', 'Praline', { sweet: 1 }],
      ['toffee', 'Toffee', { sweet: 1 }],
      ['vanilla', 'Vanilla', { sweet: 1, amber: 0.3 }],
      ['tonka', 'Tonka Bean', { sweet: 0.8, amber: 0.5 }],
      ['benzoin', 'Benzoin', { amber: 0.8, sweet: 0.5 }],
      ['bergamot', 'Bergamot', { citrus: 1, fresh: 0.3 }],
      ['lemon', 'Lemon', { citrus: 1, fresh: 0.4 }],
      ['grapefruit', 'Grapefruit', { citrus: 1, fresh: 0.3 }],
      ['mandarin', 'Mandarin', { citrus: 1, fruity: 0.3 }],
      ['orange', 'Orange', { citrus: 1, fruity: 0.3 }],
      ['petitgrain', 'Petitgrain', { citrus: 0.7, green: 0.6 }],
      ['verbena', 'Verbena', { citrus: 0.7, green: 0.6 }],
      ['citrus', 'Citrus', { citrus: 1 }],
      ['seaweed', 'Seaweed', { fresh: 1, green: 0.3 }],
      ['sea', 'Sea Notes', { fresh: 1 }],
      ['marine', 'Marine Accord', { fresh: 1 }],
      ['calone', 'Calone', { fresh: 1 }],
      ['water', 'Watery Notes', { fresh: 1 }],
      ['salt', 'Sea Salt', { fresh: 0.9 }],
      ['mint', 'Mint', { fresh: 0.9, green: 0.6 }],
      ['bamboo', 'Bamboo', { green: 1, fresh: 0.3 }],
      ['clary sage', 'Clary Sage', { green: 1 }],
      ['sage', 'Sage', { green: 1 }],
      ['lavender', 'Lavender', { green: 0.8, fresh: 0.3, floral: 0.3 }],
      ['geranium', 'Geranium', { green: 0.6, floral: 0.5 }],
      ['herb', 'Aromatic Herbs', { green: 1 }],
      ['aromatic spice', 'Aromatic Spices', { spicy: 1 }],
      ['aromatic', 'Aromatic Notes', { green: 0.9 }],
      ['green', 'Green Notes', { green: 1 }],
      ['pineapple', 'Pineapple', { fruity: 1, fresh: 0.2 }],
      ['apple', 'Apple', { fruity: 1 }],
      ['pear', 'Pear', { fruity: 1 }],
      ['blackcurrant', 'Blackcurrant', { fruity: 1 }],
      ['mango', 'Mango', { fruity: 1, sweet: 0.3 }],
      ['strawberry', 'Strawberry', { fruity: 1, sweet: 0.3 }],
      ['lychee', 'Lychee', { fruity: 1 }],
      ['kiwi', 'Kiwi', { fruity: 1, fresh: 0.2 }],
      ['peach', 'Peach', { fruity: 1, sweet: 0.2 }],
      ['tropical', 'Tropical Fruits', { fruity: 1 }],
      ['fruit', 'Fruity Notes', { fruity: 1 }],
      ['osmanthus', 'Osmanthus', { floral: 0.8, fruity: 0.4 }],
      ['jasmine', 'Jasmine', { floral: 1 }],
      ['tuberose', 'Tuberose', { floral: 1 }],
      ['rose', 'Rose', { floral: 1 }],
      ['peony', 'Peony', { floral: 1 }],
      ['iris', 'Iris', { floral: 0.7, musk: 0.6 }],
      ['orris', 'Iris', { floral: 0.7, musk: 0.6 }],
      ['violet', 'Violet', { floral: 0.8, musk: 0.4 }],
      ['muguet', 'Lily of the Valley', { floral: 1, green: 0.3 }],
      ['lily', 'Lily of the Valley', { floral: 1, green: 0.3 }],
      ['marigold', 'Marigold', { floral: 0.8, green: 0.3 }],
      ['bellflower', 'Bellflower', { floral: 1 }],
      ['wisteria', 'Wisteria', { floral: 1 }],
      ['lilac', 'Lilac', { floral: 1, green: 0.2 }],
      ['orchid', 'Orchid', { floral: 0.8, sweet: 0.4 }],
      ['hedione', 'Hedione', { floral: 0.7, fresh: 0.4 }],
      ['mahonial', 'Mahonial', { floral: 0.8 }],
      ['floral', 'Floral Notes', { floral: 1 }],
      ['cinnamon', 'Cinnamon', { spicy: 1, sweet: 0.3 }],
      ['cardamom', 'Cardamom', { spicy: 0.9, fresh: 0.2 }],
      ['saffron', 'Saffron', { spicy: 0.8, leather: 0.5 }],
      ['ginger', 'Ginger', { spicy: 0.8, fresh: 0.3 }],
      ['nutmeg', 'Nutmeg', { spicy: 1 }],
      ['elemi', 'Elemi', { spicy: 0.5, amber: 0.5, fresh: 0.3 }],
      ['spic', 'Spices', { spicy: 1 }],
      ['suede', 'Suede', { leather: 0.9, musk: 0.3 }],
      ['leather', 'Leather', { leather: 1 }],
      ['birch', 'Birch', { leather: 0.8, woody: 0.5 }],
      ['smok', 'Smoky Notes', { leather: 0.9, woody: 0.3 }],
      ['incense', 'Incense', { amber: 0.8, leather: 0.5 }],
      ['labdanum', 'Labdanum', { amber: 1, leather: 0.3 }],
      ['resin', 'Resins', { amber: 1 }],
      ['amberwood', 'Amberwood', { woody: 0.8, amber: 0.7 }],
      ['amber wood', 'Amberwood', { woody: 0.8, amber: 0.7 }],
      ['ambergris', 'Ambergris', { amber: 0.8, fresh: 0.3, musk: 0.3 }],
      ['ambroxan', 'Ambroxan', { amber: 0.8, musk: 0.4, fresh: 0.2 }],
      ['ambrofix', 'Ambroxan', { amber: 0.8, musk: 0.4, fresh: 0.2 }],
      ['ambrette', 'Ambrette', { musk: 1, floral: 0.2 }],
      ['amber', 'Amber', { amber: 1, sweet: 0.2 }],
      ['cashmeran', 'Cashmeran', { woody: 0.7, musk: 0.7 }],
      ['akigalawood', 'Akigalawood', { woody: 0.9, spicy: 0.4 }],
      ['sandalwood', 'Sandalwood', { woody: 1, musk: 0.3 }],
      ['cedar', 'Cedarwood', { woody: 1 }],
      ['vetiver', 'Vetiver', { woody: 0.9, green: 0.4 }],
      ['patchouli', 'Patchouli', { woody: 0.8, amber: 0.4 }],
      ['oakmoss', 'Oakmoss', { woody: 0.7, green: 0.6 }],
      ['guaiac', 'Guaiac Wood', { woody: 0.9, leather: 0.4 }],
      ['papyrus', 'Papyrus', { woody: 0.9, green: 0.2 }],
      ['cypriol', 'Cypriol', { woody: 0.8, leather: 0.5 }],
      ['wood', 'Woody Notes', { woody: 1 }],
      // ---- broad Emper catches, after every specific entry ----
      ['pine', 'Pine', { green: 0.8, woody: 0.6 }],
      ['oak', 'Oak', { woody: 1 }],
      ['moss', 'Moss', { green: 0.7, woody: 0.5 }],
      ['grass', 'Grass', { green: 1, fresh: 0.3 }],
      ['hay', 'Hay', { green: 0.6, sweet: 0.4 }],
      ['wheat', 'Wheat', { green: 0.5, sweet: 0.4 }],
      ['sugar', 'Sugar', { sweet: 1 }],
      ['whipped cream', 'Whipped Cream', { sweet: 0.8, musk: 0.5 }],
      ['panacotta', 'Panna Cotta', { sweet: 0.9, musk: 0.4 }],
      ['kulfi', 'Kulfi', { sweet: 0.9, musk: 0.4 }],
      ['confection', 'Confectionery Accord', { sweet: 1 }],
      ['cream', 'Cream', { sweet: 0.8, musk: 0.5 }],
      ['milk', 'Milk', { sweet: 0.7, musk: 0.6 }],
      ['nutty', 'Nutty Accord', { sweet: 0.8, woody: 0.3 }],
      ['powder', 'Powdery Notes', { musk: 0.9, floral: 0.3 }],
      ['musk', 'Musk', { musk: 1 }]
    ];

    // Everyday words people use to describe a scent -> accords (note names such as oud, honey, chocolate are read as notes instead)
    var WORDS = {
      fresh: { fresh: 1, citrus: 0.7, green: 0.4 }, clean: { fresh: 0.9, musk: 0.7, citrus: 0.5 }, crisp: { fresh: 1, citrus: 0.6, green: 0.4 },
      airy: { fresh: 0.8, musk: 0.6 }, soapy: { musk: 1, fresh: 0.5 }, shower: { fresh: 1, musk: 0.5 }, cool: { fresh: 1, green: 0.4 },
      ocean: { fresh: 1 }, oceanic: { fresh: 1 }, aquatic: { fresh: 1 }, beachy: { fresh: 1, citrus: 0.5, fruity: 0.3 }, breezy: { fresh: 1, citrus: 0.5 },
      zesty: { citrus: 1, fresh: 0.4 }, citrusy: { citrus: 1 }, tangy: { citrus: 1, fruity: 0.4 },
      sweet: { sweet: 1, fruity: 0.3 }, sugary: { sweet: 1 }, dessert: { sweet: 1 }, gourmand: { sweet: 1, amber: 0.3 }, candy: { sweet: 1, fruity: 0.5 },
      creamy: { sweet: 0.7, musk: 0.5, woody: 0.3 }, yummy: { sweet: 1 }, edible: { sweet: 1 },
      warm: { amber: 1, sweet: 0.6, spicy: 0.4 }, cozy: { sweet: 0.9, amber: 0.9, musk: 0.3 }, cosy: { sweet: 0.9, amber: 0.9, musk: 0.3 },
      comforting: { sweet: 0.9, amber: 0.8, musk: 0.4 }, spicy: { spicy: 1 }, peppery: { spicy: 1 }, hot: { spicy: 0.8, amber: 0.5 },
      woody: { woody: 1 }, woodsy: { woody: 1 }, forest: { woody: 0.9, green: 0.8 }, earthy: { woody: 0.9, green: 0.5 }, mossy: { woody: 0.6, green: 0.8 },
      floral: { floral: 1 }, flowery: { floral: 1 }, flowers: { floral: 1 }, flower: { floral: 1 },
      bouquet: { floral: 1 }, romantic: { floral: 0.8, sweet: 0.5, musk: 0.4 }, fruity: { fruity: 1 }, juicy: { fruity: 1, citrus: 0.4 },
      berry: { fruity: 1 }, berries: { fruity: 1 }, musky: { musk: 1 }, powdery: { musk: 0.9, floral: 0.4 }, soft: { musk: 0.9, floral: 0.4 },
      skin: { musk: 1 }, smoky: { leather: 1, woody: 0.4 }, smokey: { leather: 1, woody: 0.4 }, leathery: { leather: 1 }, dark: { leather: 0.8, amber: 0.8, woody: 0.5 },
      mysterious: { amber: 0.9, leather: 0.7, spicy: 0.5 }, deep: { amber: 0.8, woody: 0.8 }, rich: { amber: 0.9, sweet: 0.5, woody: 0.4 },
      oriental: { amber: 1, spicy: 0.7, sweet: 0.4 }, arabian: { amber: 1, spicy: 0.7, leather: 0.5, woody: 0.5 }, herbal: { green: 1 }, natural: { green: 0.9, woody: 0.4 },
      sexy: { amber: 0.9, sweet: 0.6, musk: 0.6 }, seductive: { amber: 0.9, sweet: 0.6, spicy: 0.5 }, sensual: { amber: 0.8, musk: 0.8, sweet: 0.4 },
      elegant: { floral: 0.6, woody: 0.6, musk: 0.5 }, classy: { woody: 0.7, amber: 0.5, musk: 0.4 }, sophisticated: { woody: 0.7, amber: 0.5, floral: 0.4 },
      luxurious: { amber: 0.7, woody: 0.6, leather: 0.4 }, masculine: { woody: 0.8, leather: 0.5, green: 0.4 }, feminine: { floral: 0.9, fruity: 0.4, musk: 0.4 },
      playful: { fruity: 0.9, sweet: 0.6 }, fun: { fruity: 0.9, sweet: 0.5, citrus: 0.4 }, energetic: { citrus: 1, fresh: 0.6, fruity: 0.4 },
      sporty: { fresh: 1, citrus: 0.8, green: 0.4 }, exotic: { fruity: 0.7, spicy: 0.6, amber: 0.5 },
      athlete: { fresh: 1, citrus: 0.8, green: 0.4 }, athletic: { fresh: 1, citrus: 0.8, green: 0.4 }, sport: { fresh: 1, citrus: 0.8, green: 0.4 },
      workout: { fresh: 1, citrus: 0.8, green: 0.4 }, training: { fresh: 1, citrus: 0.8, green: 0.4 }, active: { fresh: 1, citrus: 0.7, green: 0.4 },
      running: { fresh: 1, citrus: 0.8, green: 0.4 }, football: { fresh: 1, citrus: 0.8, green: 0.4 }, sweat: { fresh: 1, citrus: 0.7, musk: 0.4 },
      sweaty: { fresh: 1, citrus: 0.7, musk: 0.4 }, outdoors: { green: 0.9, fresh: 0.7, woody: 0.5 }, hiking: { green: 0.9, woody: 0.7, fresh: 0.5 },
      travel: { fresh: 0.8, citrus: 0.6, woody: 0.3 }, professional: { woody: 0.6, fresh: 0.5, musk: 0.5 }, confident: { woody: 0.7, spicy: 0.5, amber: 0.5 },
      manly: { woody: 0.8, leather: 0.5, green: 0.4 }, girly: { fruity: 0.8, floral: 0.8, sweet: 0.5 }, relaxing: { green: 0.8, musk: 0.6, woody: 0.4 },
      calm: { green: 0.7, musk: 0.6, woody: 0.5 }, happy: { citrus: 0.9, fruity: 0.7 }, expensive: { amber: 0.7, woody: 0.7, leather: 0.4 },
      citrus: { citrus: 1 }, wood: { woody: 1 }, fruit: { fruity: 1 }, spice: { spicy: 1 }, green: { green: 1 }, aromatic: { green: 0.9 },
      marine: { fresh: 1 }, sea: { fresh: 1 }, water: { fresh: 1 }, watery: { fresh: 1 }, gourmet: { sweet: 1 },
      attar: { amber: 0.9, woody: 0.8, floral: 0.4 }, bakhoor: { amber: 0.9, woody: 0.7, leather: 0.4 }, bukhoor: { amber: 0.9, woody: 0.7, leather: 0.4 },
      arabic: { amber: 1, woody: 0.7, spicy: 0.6, leather: 0.4 }, royal: { amber: 0.8, woody: 0.7, leather: 0.4 }, majestic: { amber: 0.8, woody: 0.7, spicy: 0.4 },
      khaleeji: { amber: 1, woody: 0.8, floral: 0.5 }, desert: { amber: 0.9, woody: 0.6, spicy: 0.5 }, nutty: { sweet: 0.8, woody: 0.3 }
    };

    var VIBES = {
      fresh: { citrus: 1, fresh: 1, green: 0.7, musk: 0.3 },
      cozy: { sweet: 1, amber: 1, woody: 0.4, spicy: 0.3, musk: 0.3 },
      bold: { spicy: 1, leather: 0.9, amber: 0.6, woody: 0.6 },
      fruity: { fruity: 1, sweet: 0.7, citrus: 0.3 },
      floral: { floral: 1, musk: 0.6, fruity: 0.2 },
      woody: { woody: 1, green: 0.5, amber: 0.4, musk: 0.3 },
      arabian: { amber: 1, woody: 0.9, spicy: 0.6, leather: 0.5, floral: 0.3 }
    };

    // Occasion: accords it leans on, strength bias, and words that mark it in a product's "Best for ..." line
    var OCCASIONS = {
      everyday: { v: { citrus: 0.6, fresh: 0.6, green: 0.5, musk: 0.5, woody: 0.3 }, i: -0.3, words: ['office', 'work', 'daily', 'everyday', 'every day', 'day wear', 'daytime', 'casual', 'gym', 'school', 'meeting'] },
      date: { v: { sweet: 0.7, amber: 0.7, spicy: 0.4, floral: 0.4, musk: 0.4 }, i: 0.3, words: ['date', 'romantic', 'romance', 'evening', 'dinner', 'intimate'] },
      night: { v: { sweet: 0.6, amber: 0.6, spicy: 0.6, fruity: 0.5, leather: 0.4 }, i: 0.5, words: ['party', 'parties', 'night out', 'nights out', 'club', 'clubbing', 'celebrat'] },
      sunny: { v: { citrus: 0.9, fresh: 0.9, fruity: 0.6, green: 0.4 }, i: -0.5, words: ['summer', 'beach', 'hot ', 'vacation', 'holiday', 'spring', 'sunny', 'pool', 'brunch'] },
      special: { v: { woody: 0.6, amber: 0.6, floral: 0.5, leather: 0.4, spicy: 0.4 }, i: 0.3, words: ['special', 'wedding', 'formal', 'occasion', 'gala', 'event', 'signature', 'gift'] },
      cold: { v: { amber: 0.9, sweet: 0.7, spicy: 0.6, woody: 0.5 }, i: 0.4, words: ['winter', 'cold', 'autumn', 'fall ', 'cool evening', 'cooler'] }
    };

    var GENDER_WORDS = {
      men: ['men', 'man', 'him', 'male', 'guy', 'husband', 'boyfriend', 'dad', 'father', 'brother', 'groom', 'mens', 'gentleman'],
      women: ['women', 'woman', 'her', 'female', 'lady', 'girl', 'wife', 'girlfriend', 'mom', 'mum', 'mother', 'sister', 'bride', 'womens', 'ladies']
    };
    var STRONG_WORDS = ['strong', 'bold', 'powerful', 'intense', 'loud', 'heavy', 'beast', 'projection', 'noticeable'];
    // Staying power is its own wish: a fresh scent can be asked to last without being asked to be heavy
    var LASTING_WORDS = ['long lasting', 'longlasting', 'lasting', 'lasts', 'stay', 'stays', 'fade', 'fades', 'all day', 'whole day', 'hours', 'the same', 'after the', 'after a',
      'after my', 'endurance', 'sweat', 'sweaty', 'athlete', 'athletic', 'workout', 'training', 'game', 'longevity'];
    // Everyday words that sit one typo away from scent vocabulary and must not be "corrected" into it
    var NOT_TYPOS = ['there', 'these', 'those', 'their', 'where', 'which', 'while', 'would', 'could', 'should', 'about', 'after', 'other', 'smell', 'smells', 'really', 'think',
      'thing', 'great', 'perfume', 'perfumes', 'scent', 'scents', 'fragrance', 'something', 'someone', 'always', 'every', 'still', 'please', 'thanks', 'makes', 'people',
      'wants', 'needs', 'looks', 'feels', 'first', 'going', 'being', 'having', 'swear', 'sweep', 'sheet', 'short', 'sport', 'store', 'clear', 'wears', 'lasted'];
    var LIGHT_WORDS = ['subtle', 'light', 'mild', 'gentle', 'delicate', 'discreet', 'quiet', 'soft'];
    var NEGATORS = ['no', 'not', 'without', 'hate', 'dislike', 'avoid', 'less', 'never', 'nothing', 'dont', 'isnt', 'cant', 'too', 'overly', 'except'];
    var POSITIVES = ['love', 'like', 'want', 'prefer', 'need', 'enjoy', 'adore', 'but', 'with', 'looking'];

    var LAYER_WEIGHT = { top: 0.7, heart: 1, base: 1.1 };

    function emptyVec() { var v = {}; FACETS.forEach(function (f) { v[f] = 0; }); return v; }
    function addVec(target, source, weight) { for (var k in source) { if (k in target) target[k] += source[k] * (weight == null ? 1 : weight); } return target; }
    function maxOf(v) { var m = 0; FACETS.forEach(function (f) { if (v[f] > m) m = v[f]; }); return m; }
    function normalise(v) {
      var m = maxOf(v);
      var out = emptyVec();
      if (m > 0) FACETS.forEach(function (f) { out[f] = Math.max(0, v[f]) / m; });
      return out;
    }
    function cosine(a, b) {
      var dot = 0, na = 0, nb = 0;
      FACETS.forEach(function (f) { var x = Math.max(0, a[f]), y = Math.max(0, b[f]); dot += x * y; na += x * x; nb += y * y; });
      return na && nb ? dot / Math.sqrt(na * nb) : 0;
    }
    function clamp(n, lo, hi) { return Math.min(hi, Math.max(lo, n)); }

    // Short keywords that also hide inside other words ("cloud", "sublime", "ginger") only count as whole words
    var WHOLE_WORDS = ['oud', 'gin', 'rum', 'lime', 'fig', 'hay', 'oak', 'pine', 'moss', 'plum', 'tea', 'sea', 'salt', 'mate'];
    function hasNote(name, keyword) {
      var at = name.indexOf(keyword);
      if (at === -1) return false;
      if (WHOLE_WORDS.indexOf(keyword) === -1) return true;
      var re = new RegExp('(^|[\\s\\-/])' + keyword + '(e?s)?($|[\\s\\-/])');
      return re.test(name);
    }

    function lookupNote(raw) {
      var name = String(raw || '').toLowerCase().replace(/\(.*?\)/g, ' ').replace(/[^a-z\s\-\/]/g, ' ').replace(/\s+/g, ' ').trim();
      if (!name) return null;
      // "Oud (Agarwood)": the bracket is dropped above, so read it separately when the name itself is unknown
      for (var i = 0; i < NOTES.length; i++) {
        if (hasNote(name, NOTES[i][0])) return { key: NOTES[i][1].toLowerCase(), name: NOTES[i][1], facets: NOTES[i][2] };
      }
      return null;
    }

    // Reads "Top Notes: a, b" / "Heart Notes: ..." / "Base Notes: ..." out of a product description; "Top: a, b"
    // (no "Notes") counts too. Labelled lines (with a colon) win over loose wording such as "vibrant top notes and
    // a rich finish". A bottle holding two scents lists Top / Middle / Base twice: both scents' notes are read,
    // each note once.
    function parsePyramid(html) {
      var text = String(html || '').replace(/<[^>]+>/g, '|').replace(/&amp;/g, '&').replace(/&nbsp;/g, ' ').replace(/&[a-z#0-9]+;/gi, ' ');
      var labelled = { top: [], heart: [], base: [] };
      var loose = { top: [], heart: [], base: [] };
      var re = /(top|head|middle|heart|base)(\s*notes?\s*:?|\s*:)[\s|]*([^|]+)/gi, match;
      while ((match = re.exec(text))) {
        var label = match[1].toLowerCase();
        var layer = label === 'top' || label === 'head' ? 'top' : label === 'base' ? 'base' : 'heart';
        var into = match[2].indexOf(':') === -1 ? loose[layer] : labelled[layer];
        if (into === loose[layer] && into.length) continue;
        match[3].split(/,|;|•/).forEach(function (part) {
          var note = part.replace(/\s+/g, ' ').replace(/[.\s]+$/, '').replace(/^[:\s]+/, '').replace(/^and\s+/i, '').trim();
          var known = into.some(function (seen) { return seen.toLowerCase() === note.toLowerCase(); });
          if (note && note.length < 40 && !known) into.push(note);
        });
      }
      return {
        top: labelled.top.length ? labelled.top : loose.top,
        heart: labelled.heart.length ? labelled.heart : loose.heart,
        base: labelled.base.length ? labelled.base : loose.base
      };
    }

    // Product -> accord profile, canonical notes and strength
    function profile(product) {
      var layers = product.pyramid || parsePyramid(product.desc);
      var vec = emptyVec(), notes = [], seen = {};
      ['top', 'heart', 'base'].forEach(function (layer) {
        layers[layer].forEach(function (raw) {
          var hit = lookupNote(raw);
          notes.push({ raw: raw, layer: layer, key: hit ? hit.key : raw.toLowerCase(), name: hit ? hit.name : raw, facets: hit ? hit.facets : {} });
          if (hit) { addVec(vec, hit.facets, LAYER_WEIGHT[layer]); seen[hit.key] = true; }
        });
      });
      (product.main || []).forEach(function (main) {
        var hit = lookupNote(main.l);
        if (hit) { addVec(vec, hit.facets, 0.8); seen[hit.key] = true; }
      });
      var total = 0; FACETS.forEach(function (f) { total += vec[f]; });
      var heavy = vec.amber + vec.leather + vec.spicy + vec.sweet + vec.woody * 0.6;
      var light = vec.citrus + vec.fresh + vec.green + vec.fruity * 0.4;
      var strength = total ? (heavy - light) / total : 0;
      if (/extrait/i.test(product.conc || '')) strength += 0.2;
      var anchors = [];
      notes.forEach(function (note) {
        var holds = (note.facets.woody || 0) >= 0.7 || (note.facets.amber || 0) >= 0.7 || (note.facets.musk || 0) >= 0.7 || (note.facets.leather || 0) >= 0.7;
        if (note.layer === 'base' && holds && anchors.indexOf(note.name) === -1) anchors.push(note.name);
      });
      return {
        layers: layers, notes: notes, keys: seen, vec: normalise(vec), strength: clamp(strength * 1.6, -1, 1),
        extrait: /extrait/i.test(product.conc || ''), anchors: anchors
      };
    }

    // Edit distance with swapped neighbours counted once ("vanlila" -> "vanilla")
    function distance(a, b) {
      var rows = [], i, j;
      for (i = 0; i <= a.length; i++) { rows[i] = [i]; }
      for (j = 1; j <= b.length; j++) { rows[0][j] = j; }
      for (i = 1; i <= a.length; i++) {
        for (j = 1; j <= b.length; j++) {
          var cost = a.charAt(i - 1) === b.charAt(j - 1) ? 0 : 1;
          rows[i][j] = Math.min(rows[i - 1][j] + 1, rows[i][j - 1] + 1, rows[i - 1][j - 1] + cost);
          if (i > 1 && j > 1 && a.charAt(i - 1) === b.charAt(j - 2) && a.charAt(i - 2) === b.charAt(j - 1)) rows[i][j] = Math.min(rows[i][j], rows[i - 2][j - 2] + 1);
        }
      }
      return rows[a.length][b.length];
    }

    var knownWords = null;
    function known() {
      if (knownWords) return knownWords;
      var seen = {};
      function add(word) { word = String(word).trim(); if (word.length >= 5 && word.indexOf(' ') === -1) seen[word] = true; }
      Object.keys(WORDS).forEach(add);
      NOTES.forEach(function (entry) { add(entry[0]); add(entry[1].toLowerCase()); });
      for (var occasion in OCCASIONS) OCCASIONS[occasion].words.forEach(add);
      GENDER_WORDS.men.concat(GENDER_WORDS.women, STRONG_WORDS, LIGHT_WORDS, LASTING_WORDS).forEach(add);
      knownWords = Object.keys(seen);
      return knownWords;
    }
    // "athelete" -> "athlete", "vanila" -> "vanilla". Same first letter, one slip (two in long words).
    function fixTypo(word) {
      if (word.length < 5 || NOT_TYPOS.indexOf(word) !== -1) return null;
      var list = known(), allowed = word.length >= 8 ? 2 : 1, best = null, bestDistance = allowed + 1;
      for (var i = 0; i < list.length; i++) {
        var candidate = list[i];
        if (candidate === word) return null;
        if (candidate.charAt(0) !== word.charAt(0) || Math.abs(candidate.length - word.length) > allowed) continue;
        var d = distance(word, candidate);
        if (d < bestDistance) { best = candidate; bestDistance = d; }
      }
      return best;
    }

    function tokens(text) {
      return String(text || '').toLowerCase().replace(/[’']/g, '').replace(/([,.;!?\n])/g, ' $1 ').replace(/[^a-z0-9,.;!?\s\-]/g, ' ').split(/\s+/).filter(Boolean);
    }

    // Whole-phrase note lookup for typed text ("rose", "orange blossom", "woods")
    function exactNote(chunk) {
      for (var i = 0; i < NOTES.length; i++) {
        if (chunk === NOTES[i][0] || chunk === NOTES[i][1].toLowerCase()) return { key: NOTES[i][1].toLowerCase(), name: NOTES[i][1], facets: NOTES[i][2] };
      }
      return null;
    }

    // Free text -> preferences
    function readText(text) {
      var words = tokens(text);
      var out = { vec: emptyVec(), loves: [], avoids: [], gender: null, occasion: null, intensity: 0, lasting: false, hits: 0 };
      var negate = false, lastNegator = -9, corrected = {};

      function singular(word) { return word.length > 4 && /s$/.test(word) ? word.replace(/ies$/, 'y').replace(/s$/, '') : word; }
      function inList(list, a, b) { return list.some(function (w) { w = w.trim(); return w === a || w === b; }); }

      for (var i = 0; i < words.length; i++) {
        var word = words[i];
        if (/^[,.;!?]$/.test(word)) { negate = false; continue; }
        if (NEGATORS.indexOf(word) !== -1) { negate = true; lastNegator = i; continue; }
        if (POSITIVES.indexOf(word) !== -1) {
          if (i - lastNegator > 1) negate = false;
          continue;
        }

        for (var n = 3; n >= 1; n--) {
          if (i + n > words.length) continue;
          var chunk = words.slice(i, i + n).join(' ');
          var single = n === 1 ? singular(chunk) : chunk.replace(/s$/, '');
          var matched = false;

          // Occasions and gender are never negated
          for (var occasion in OCCASIONS) {
            if (!matched && inList(OCCASIONS[occasion].words, chunk, single)) { out.occasion = out.occasion || occasion; matched = true; }
          }
          if (!matched && n === 1 && inList(GENDER_WORDS.men, chunk, single)) { out.gender = out.gender || 'men'; matched = true; }
          if (!matched && n === 1 && inList(GENDER_WORDS.women, chunk, single)) { out.gender = out.gender || 'women'; matched = true; }
          if (!matched && (LASTING_WORDS.indexOf(chunk) !== -1 || LASTING_WORDS.indexOf(single) !== -1)) {
            if (!negate) out.lasting = true;
            if (n === 1 && (WORDS[chunk] || WORDS[single])) addVec(out.vec, WORDS[chunk] || WORDS[single], negate ? -0.9 : 1);
            matched = true;
          }
          if (!matched && STRONG_WORDS.indexOf(chunk) !== -1) { out.intensity += negate ? -0.6 : 0.6; matched = true; }
          if (!matched && LIGHT_WORDS.indexOf(chunk) !== -1) {
            out.intensity += negate ? 0.4 : -0.6;
            if (WORDS[chunk]) addVec(out.vec, WORDS[chunk], negate ? -0.9 : 1);
            matched = true;
          }
          if (!matched && n === 1 && (WORDS[chunk] || WORDS[single])) {
            addVec(out.vec, WORDS[chunk] || WORDS[single], negate ? -0.9 : 1);
            matched = true;
          }
          if (!matched) {
            var note = exactNote(chunk) || exactNote(single);
            if (note) {
              var list = negate ? out.avoids : out.loves;
              if (list.indexOf(note.key) === -1) list.push(note.key);
              if (!negate) addVec(out.vec, note.facets, 0.9);
              matched = true;
            }
          }
          if (matched) { out.hits++; i += n - 1; break; }

          // Nothing recognised: try once more with the spelling fixed
          if (n === 1 && !corrected[i]) {
            corrected[i] = true;
            var fixed = fixTypo(word) || fixTypo(single);
            if (fixed) { words[i] = fixed; i--; break; }
          }
        }
      }
      out.intensity = clamp(out.intensity, -1, 1);
      return out;
    }

    // "Club 09" / "club 9" / "club09" -> "club9", "date nights" -> "datenight"
    function titleKey(words) {
      return words.map(function (word) { return /^\d+$/.test(word) ? String(Number(word)) : word; }).join('').replace(/-/g, '').replace(/s$/, '');
    }

    // Perfumes asked for by name ("I want date night", "something like club 9", "not imperial"), negated the same way readText is
    function named(products, text) {
      var words = tokens(text), out = { loves: [], avoids: [] }, negate = false, lastNegator = -9;
      var titles = products.map(function (product) { var parts = tokens(product.t); return { h: product.h, size: parts.length, key: titleKey(parts) }; })
        .filter(function (title) { return title.key.length >= 4; });
      for (var i = 0; i < words.length; i++) {
        var word = words[i];
        if (/^[,.;!?]$/.test(word)) { negate = false; continue; }
        if (NEGATORS.indexOf(word) !== -1) { negate = true; lastNegator = i; continue; }
        if (POSITIVES.indexOf(word) !== -1 && i - lastNegator > 1) negate = false;
        titles.forEach(function (title) {
          // The typed name may run together or split apart, so try one word fewer and one more than the title
          for (var n = Math.max(1, title.size - 1); n <= title.size + 1 && i + n <= words.length; n++) {
            var chunk = words.slice(i, i + n);
            if (chunk.some(function (w) { return /^[,.;!?]$/.test(w); })) break;
            var key = titleKey(chunk);
            var close = key === title.key || (title.key.length >= 7 && key.charAt(0) === title.key.charAt(0) &&
              Math.abs(key.length - title.key.length) <= 1 && distance(key, title.key) <= 1);
            if (close) {
              var list = negate ? out.avoids : out.loves;
              if (list.indexOf(title.h) === -1) list.push(title.h);
              break;
            }
          }
        });
      }
      return out;
    }

    // Preferences -> one accord vector
    function taste(prefs) {
      var vec = emptyVec();
      (prefs.vibes || []).forEach(function (vibe) { if (VIBES[vibe]) addVec(vec, VIBES[vibe], 1); });
      if (prefs.occasion && OCCASIONS[prefs.occasion]) addVec(vec, OCCASIONS[prefs.occasion].v, 0.6);
      (prefs.loves || []).forEach(function (key) { var hit = lookupNote(key); if (hit) addVec(vec, hit.facets, 0.7); });
      if (prefs.textVec) addVec(vec, prefs.textVec, 1);
      (prefs.avoids || []).forEach(function (key) { var hit = lookupNote(key); if (hit) addVec(vec, hit.facets, -0.25); });
      return vec;
    }

    function rank(products, prefs) {
      var user = taste(prefs);
      var hasTaste = maxOf(user) > 0;
      var wanted = clamp((prefs.intensity || 0) + (prefs.occasion && OCCASIONS[prefs.occasion] ? OCCASIONS[prefs.occasion].i * 0.5 : 0), -1, 1);
      var useStrength = prefs.intensity != null || !!prefs.occasion;
      var loves = prefs.loves || [], avoids = prefs.avoids || [];
      var asked = prefs.named || [], refused = prefs.namedAvoid || [];

      var scored = products.map(function (product) {
        var p = product.profile;
        var isNamed = asked.indexOf(product.h) !== -1;
        var similarity = hasTaste ? cosine(user, p.vec) : 0.5;
        var loved = loves.filter(function (key) { return p.keys[key]; });
        var avoided = avoids.filter(function (key) { return p.keys[key]; });
        var score = loves.length ? similarity * 0.68 + (loved.length / loves.length) * 0.32 : similarity;

        // Accords the user pushed away (from "not sweet" style text) cost points when the perfume leans on them
        FACETS.forEach(function (f) { if (user[f] < 0) score -= Math.min(0.3, -user[f] * 0.28) * p.vec[f]; });
        score -= avoided.length * 0.22;
        if (useStrength) score -= Math.abs(wanted - p.strength) * 0.09;
        // Staying power: the most concentrated strength, and a base built on woods, amber or musk
        if (prefs.lasting) score += (p.extrait ? 0.08 : 0) + Math.min(1, p.anchors.length / 4) * 0.05;

        var occasionHit = false;
        if (prefs.occasion && product.tag) {
          var line = ' ' + product.tag.toLowerCase() + ' ';
          occasionHit = OCCASIONS[prefs.occasion].words.some(function (w) { return line.indexOf(w) !== -1; });
          if (occasionHit) score += 0.07;
        }

        // A perfume asked for by name leads the results; one turned down by name drops out of them
        if (isNamed) score += 0.45;
        var isRefused = refused.indexOf(product.h) !== -1;
        if (isRefused) score -= 0.45;

        var genderOk = isNamed || !prefs.gender || prefs.gender === 'any' || product.g === 'unisex' || product.g === prefs.gender;
        if (product.avail === false) score -= 0.05;

        return { product: product, score: score, similarity: similarity, loved: loved, avoided: avoided, occasionHit: occasionHit, genderOk: genderOk, named: isNamed, refused: isRefused };
      });

      var pool = scored.filter(function (row) { return row.genderOk && !row.refused; });
      if (pool.length < 3) pool = scored;
      pool.sort(function (a, b) { return b.score - a.score; });
      pool.forEach(function (row) { row.percent = Math.round(clamp(56 + 42 * clamp(row.score, 0, 1), 50, 98)); });
      return { user: user, rows: pool };
    }

    // Which notes in a perfume carry the accords the user asked for
    function reasons(row, user, limit) {
      var p = row.product.profile, out = [];
      var wantedFacets = FACETS.filter(function (f) { return user[f] > 0 && p.vec[f] >= 0.35; })
        .sort(function (a, b) { return user[b] * p.vec[b] - user[a] * p.vec[a]; }).slice(0, limit || 3);
      var used = {};
      wantedFacets.forEach(function (facet) {
        var carriers = p.notes.filter(function (note) { return (note.facets[facet] || 0) >= 0.6 && !used[note.key]; })
          .sort(function (a, b) { return (row.loved.indexOf(b.key) !== -1) - (row.loved.indexOf(a.key) !== -1) || b.facets[facet] - a.facets[facet]; })
          .filter(function (note, index, list) { return list.findIndex(function (other) { return other.key === note.key; }) === index; })
          .slice(0, 3);
        carriers.forEach(function (note) { used[note.key] = true; });
        if (carriers.length) out.push({ facet: facet, notes: carriers.map(function (note) { return note.name; }) });
      });
      return out;
    }

    // 8 readable axes for the chart
    var AXES = [
      ['Citrus', { citrus: 1 }], ['Fresh', { fresh: 0.7, green: 0.5 }], ['Fruity', { fruity: 1 }], ['Floral', { floral: 1 }],
      ['Sweet', { sweet: 1 }], ['Spicy', { spicy: 1 }], ['Warm', { amber: 0.7, leather: 0.4, musk: 0.2 }], ['Woody', { woody: 1 }]
    ];
    function axes(vec) {
      var values = AXES.map(function (axis) {
        var sum = 0;
        for (var f in axis[1]) sum += Math.max(0, vec[f] || 0) * axis[1][f];
        return sum;
      });
      var m = Math.max.apply(null, values);
      return values.map(function (value) { return m > 0 ? value / m : 0; });
    }
    function topFacets(vec, count) {
      return FACETS.filter(function (f) { return vec[f] > 0; }).sort(function (a, b) { return vec[b] - vec[a]; })
        .filter(function (f, index, list) { return vec[f] >= vec[list[0]] * 0.45; }).slice(0, count || 3);
    }

    return {
      FACETS: FACETS, AXES: AXES.map(function (axis) { return axis[0]; }), VIBES: VIBES, OCCASIONS: OCCASIONS,
      lookupNote: lookupNote, parsePyramid: parsePyramid, profile: profile, readText: readText, named: named, taste: taste,
      rank: rank, reasons: reasons, axes: axes, topFacets: topFacets, emptyVec: emptyVec
    };
  })();
/* ---------- Interface ---------- */
(function () {
  var E = ScentEngine;
  var STEPS = ['who', 'vibe', 'occasion', 'notes', 'strength'];
  var STORE_KEY = 'emper-scent-finder';
  var FACET_LABELS = { citrus: 'Citrus', fresh: 'Fresh', green: 'Aromatic', fruity: 'Fruity', floral: 'Floral', spicy: 'Spicy', sweet: 'Sweet', woody: 'Woody', amber: 'Warm amber', musk: 'Soft musk', leather: 'Smoky' };
  // Scent colours, warmed to sit with terracotta and cream
  var FACET_COLORS = { citrus: '#e9b23c', fresh: '#5fa8b8', green: '#7c9a5c', fruity: '#d9576a', floral: '#c98aa8', spicy: '#c4562e', sweet: '#d99a62', woody: '#8a5a36', amber: '#c9822a', musk: '#cdbfae', leather: '#6b4a3a' };
  var DEFAULT_COLORS = ['#b75c3f', '#d9a26a', '#8f4128'];
  var VIBE_LABELS = { fresh: 'Fresh & clean', cozy: 'Warm & cozy', bold: 'Bold & spicy', fruity: 'Sweet & fruity', floral: 'Soft & floral', woody: 'Deep & woody', arabian: 'Rich & Arabian' };
  var OCCASION_LABELS = { everyday: 'Every day', date: 'Date night', night: 'Nights out', sunny: 'Sunny days', special: 'Special occasions', cold: 'Cool evenings' };
  // Family words and aroma-chemical names are matched on, but not offered as chips
  var NOT_A_CHIP = /(notes|accord|fruits|spices|herbs|resins|flowers)$|^(citrus|calone|hedione|mahonial|akigalawood|cashmeran|ambroxan|ambrette|cypriol|elemi|labdanum|papyrus|benzoin|amberwood|coumarin|caramelised sugar|aldehydes|amyris)$/;
  var CHIP_LIMIT = 28;
  var PINNED = ['oud', 'rose', 'saffron', 'amber', 'frankincense', 'vanilla', 'musk', 'sandalwood', 'leather', 'jasmine'];
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function esc(value) {
    return String(value).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; });
  }
  function joinAnd(list) {
    if (list.length < 2) return list.join('');
    return list.slice(0, -1).join(', ') + ' and ' + list[list.length - 1];
  }
  function blankPrefs() {
    return { gender: null, vibes: [], occasion: null, loves: [], avoids: [], named: [], namedAvoid: [], intensity: null, lasting: false, textVec: null, text: '' };
  }
  function money(cents) {
    var format = (window.FoxTheme && FoxTheme.settings && FoxTheme.settings.moneyFormat) || '{{amount}}';
    if (window.FoxTheme && FoxTheme.Currency && FoxTheme.Currency.formatMoney) return FoxTheme.Currency.formatMoney(cents, format);
    return (cents / 100).toFixed(2);
  }
  function genderOf(tags) {
    var gender = 'unisex';
    for (var i = 0; i < tags.length; i++) {
      var tag = String(tags[i]).toLowerCase().trim();
      if (tag === 'unisex') return 'unisex';
      if (tag === 'men' || tag === 'man') gender = 'men';
      else if (tag === 'women' || tag === 'woman') gender = 'women';
    }
    return gender;
  }

  function init(root) {
    if (root.dataset.sfReady) return;
    root.dataset.sfReady = 'true';

    function $(selector) { return root.querySelector(selector); }
    function $$(selector) { return Array.prototype.slice.call(root.querySelectorAll(selector)); }

    var rootUrl = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var cartAddUrl = (window.FoxTheme && FoxTheme.routes && FoxTheme.routes.cart_add_url) || rootUrl + 'cart/add';
    var collection = root.getAttribute('data-collection') || 'all';
    var productType = (root.getAttribute('data-product-type') || '').toLowerCase().trim();

    var products = [];
    var noteCount = {}, noteNames = {}, noteFacets = {};
    var prefs = blankPrefs();
    var current = 'intro';
    var timer = null;
    var textarea = $('[data-sf-text]');
    var errorEl = $('[data-sf-error]');
    var wordsEl = $('[data-sf-words]');
    var emptyWords = wordsEl.textContent;

    /* ----- Catalogue: read live from the store, so new perfumes join by themselves ----- */
    function loadPage(page) {
      var url = rootUrl + 'collections/' + encodeURIComponent(collection) + '/products.json?limit=250&page=' + page;
      return fetch(url, { headers: { Accept: 'application/json' } }).then(function (response) { return response.json(); })
        .then(function (json) { return (json && json.products) || []; });
    }
    function loadAll() {
      var all = [];
      function next(page) {
        return loadPage(page).then(function (list) {
          all = all.concat(list);
          return list.length === 250 && page < 8 ? next(page + 1) : all;
        });
      }
      return next(1);
    }
    var ready = loadAll().then(function (list) {
      products = list.filter(function (item) {
        return !productType || String(item.product_type || '').toLowerCase().trim() === productType;
      }).map(function (item) {
        var variant = item.variants.filter(function (v) { return v.available; })[0] || item.variants[0] || {};
        return {
          h: item.handle, t: item.title, g: genderOf(item.tags || []), desc: item.body_html || '', vendor: item.vendor,
          avail: item.variants.some(function (v) { return v.available; }),
          img: item.images && item.images[0] ? item.images[0].src : '', variant: variant.id,
          price: Math.round(parseFloat(variant.price || 0) * 100), compare: Math.round(parseFloat(variant.compare_at_price || 0) * 100)
        };
      }).filter(function (product) {
        product.profile = E.profile(product);
        if (product.profile.notes.length < 3) return false;
        // Occasion words are read from the prose of the description
        product.tag = product.desc.replace(/<[^>]+>/g, ' ').replace(/(top|head|middle|heart|base)(\s*notes?)?\s*:[^.]*/gi, ' ').toLowerCase();
        // the set of recognised notes: sizes of one perfume, and twins sold under two names, share it
        product.noteSet = {};
        product.profile.notes.forEach(function (note) { if (Object.keys(note.facets).length) product.noteSet[note.key] = true; });
        var counted = {};
        product.profile.notes.forEach(function (note) {
          if (!Object.keys(note.facets).length || counted[note.key]) return;
          counted[note.key] = true;
          noteCount[note.key] = (noteCount[note.key] || 0) + 1;
          noteNames[note.key] = note.name;
          noteFacets[note.key] = note.facets;
        });
        return true;
      });
      $('[data-sf-stat]').textContent = products.length ? products.length + ' perfumes · ' + Object.keys(noteCount).length + ' notes read' : '';
      buildChips();
      restore();
      root.classList.add('is-loaded');
      return products;
    }).catch(function () {
      $('[data-sf-stat]').textContent = '';
      return products;
    });

    /* ----- Signature chart ----- */
    var AXIS_COUNT = E.AXES.length;
    var shapes = { you: $('[data-sf-shape="you"]'), match: $('[data-sf-shape="match"]') };
    var shapeValues = { you: E.AXES.map(function () { return 0; }), match: E.AXES.map(function () { return 0; }) };
    var shapeFrames = {};

    function point(index, radius) {
      var angle = (-90 + (360 / AXIS_COUNT) * index) * Math.PI / 180;
      return [Math.cos(angle) * radius, Math.sin(angle) * radius];
    }
    function polygon(values, radius) {
      return values.map(function (value, index) { var p = point(index, value * radius); return p[0].toFixed(1) + ',' + p[1].toFixed(1); }).join(' ');
    }
    (function drawGrid() {
      var html = '';
      [1 / 3, 2 / 3, 1].forEach(function (scale) {
        html += '<polygon class="scent-finder__ring" points="' + polygon(E.AXES.map(function () { return scale; }), 100) + '"></polygon>';
      });
      E.AXES.forEach(function (label, index) {
        var end = point(index, 100), at = point(index, 118);
        var anchor = Math.abs(at[0]) < 1 ? 'middle' : at[0] > 0 ? 'start' : 'end';
        html += '<line class="scent-finder__spoke" x1="0" y1="0" x2="' + end[0].toFixed(1) + '" y2="' + end[1].toFixed(1) + '"></line>';
        html += '<text data-sf-axis="' + index + '" x="' + at[0].toFixed(1) + '" y="' + at[1].toFixed(1) + '" text-anchor="' + anchor + '" dominant-baseline="middle">' + esc(label) + '</text>';
      });
      $('[data-sf-radar-grid]').innerHTML = html;
    })();

    function drawShape(name, target) {
      var el = shapes[name], from = shapeValues[name].slice(), start = null;
      var visible = target.some(function (value) { return value > 0; });
      el.style.opacity = visible ? 1 : 0;
      cancelAnimationFrame(shapeFrames[name]);
      if (reduceMotion || !visible) { shapeValues[name] = target.slice(); el.setAttribute('points', polygon(target, 100)); return; }
      function frame(now) {
        if (start === null) start = now;
        var t = Math.min(1, (now - start) / 420), eased = 1 - Math.pow(1 - t, 3);
        shapeValues[name] = from.map(function (value, index) { return value + (target[index] - value) * eased; });
        el.setAttribute('points', polygon(shapeValues[name], 100));
        if (t < 1) shapeFrames[name] = requestAnimationFrame(frame);
      }
      shapeFrames[name] = requestAnimationFrame(frame);
    }

    function updateStudio(match) {
      var vec = E.taste(prefs);
      var values = E.axes(vec);
      var top = E.topFacets(vec, 3);
      drawShape('you', values);
      drawShape('match', match ? E.axes(match.profile.vec) : E.AXES.map(function () { return 0; }));

      wordsEl.textContent = top.length ? top.map(function (facet) { return FACET_LABELS[facet]; }).join(' · ') : emptyWords;
      var palette = (match && !top.length ? E.topFacets(match.profile.vec, 3) : top).map(function (facet) { return FACET_COLORS[facet]; });
      [0, 1, 2].forEach(function (index) {
        root.style.setProperty('--sf-c' + (index + 1), palette[index] || palette[0] || DEFAULT_COLORS[index]);
      });
      $$('[data-sf-axis]').forEach(function (label) {
        label.classList.toggle('is-strong', values[Number(label.getAttribute('data-sf-axis'))] >= 0.7);
      });
      var legend = $('[data-sf-legend]');
      legend.hidden = !match;
      if (match) $('[data-sf-legend-match]').textContent = match.t;
    }

    /* ----- Screens ----- */
    function show(name, quiet) {
      clearTimeout(timer);
      current = name;
      $$('[data-sf-screen]').forEach(function (screen) {
        var active = screen.getAttribute('data-sf-screen') === name;
        screen.hidden = !active;
        screen.classList.toggle('is-active', active);
      });

      var step = STEPS.indexOf(name);
      $('[data-sf-bar]').hidden = step === -1;
      if (step !== -1) {
        $$('[data-sf-progress] span').forEach(function (bar, index) { bar.classList.toggle('is-done', index <= step); });
        $('[data-sf-count]').textContent = (step + 1) + ' / ' + STEPS.length;
      }
      if (name !== 'loading') stopScan();
      if (quiet) return;

      var heading = $('[data-sf-screen="' + name + '"] .scent-finder__title');
      if (heading && name !== 'intro') heading.focus({ preventScroll: true });
      var top = root.getBoundingClientRect().top;
      if (top < 0 || top > window.innerHeight * 0.4) root.scrollIntoView({ block: 'start', behavior: reduceMotion ? 'auto' : 'smooth' });
    }

    function syncChoices() {
      $$('[data-sf-choice]').forEach(function (button) {
        var key = button.getAttribute('data-sf-choice'), value = button.getAttribute('data-value'), pressed = false;
        if (key === 'vibes') pressed = prefs.vibes.indexOf(value) !== -1;
        else if (key === 'gender') pressed = prefs.gender === value;
        else if (key === 'occasion') pressed = value !== '' && prefs.occasion === value;
        else if (key === 'intensity') pressed = prefs.intensity !== null && prefs.intensity === parseFloat(value);
        button.setAttribute('aria-pressed', pressed ? 'true' : 'false');
      });
      $$('[data-sf-note]').forEach(function (chip) {
        var key = chip.getAttribute('data-sf-note');
        var state = prefs.loves.indexOf(key) !== -1 ? 'love' : prefs.avoids.indexOf(key) !== -1 ? 'avoid' : '';
        chip.setAttribute('data-state', state);
        chip.setAttribute('aria-label', noteNames[key] + (state ? ': ' + state : ''));
      });
      var vibeNext = $('[data-sf-screen="vibe"] [data-sf-next]');
      if (vibeNext) vibeNext.disabled = !prefs.vibes.length;
      var notesNext = $('[data-sf-screen="notes"] [data-sf-next]');
      if (notesNext) {
        var picked = $$('[data-sf-note][data-state="love"], [data-sf-note][data-state="avoid"]').length;
        notesNext.textContent = notesNext.getAttribute(picked ? 'data-label-filled' : 'data-label-empty');
      }
    }

    function lead(key) {
      var facets = noteFacets[key], best = null;
      for (var facet in facets) if (best === null || facets[facet] > facets[best]) best = facet;
      return best;
    }
    function buildChips() {
      // the house's signatures are always offered; the rest are the most used notes
      var pinned = PINNED.filter(function (key) { return noteCount[key]; });
      var keys = pinned.concat(Object.keys(noteCount)
        .filter(function (key) { return !NOT_A_CHIP.test(key) && pinned.indexOf(key) === -1; })
        .sort(function (a, b) { return noteCount[b] - noteCount[a]; }))
        .slice(0, CHIP_LIMIT);
      keys.sort(function (a, b) { return E.FACETS.indexOf(lead(a)) - E.FACETS.indexOf(lead(b)) || noteCount[b] - noteCount[a]; });
      $('[data-sf-notes]').innerHTML = keys.map(function (key) {
        return '<button type="button" class="scent-finder__note" data-sf-note="' + esc(key) + '" data-state="">' + esc(noteNames[key]) + '</button>';
      }).join('');
      syncChoices();
    }

    function advance() {
      var step = STEPS.indexOf(current);
      if (step === -1) return;
      if (step === STEPS.length - 1) finish();
      else show(STEPS[step + 1]);
    }
    function advanceSoon() {
      clearTimeout(timer);
      timer = setTimeout(advance, reduceMotion ? 0 : 280);
    }

    /* ----- Results ----- */
    function noteName(key) {
      return noteNames[key] || key.replace(/\b[a-z]/g, function (c) { return c.toUpperCase(); });
    }

    function readChips(user) {
      var chips = [];
      if (prefs.text) chips.push('“' + (prefs.text.length > 64 ? prefs.text.slice(0, 61) + '…' : prefs.text) + '”');
      if (prefs.gender === 'men') chips.push('For him');
      if (prefs.gender === 'women') chips.push('For her');
      prefs.vibes.forEach(function (vibe) { chips.push(VIBE_LABELS[vibe]); });
      if (prefs.occasion) chips.push(OCCASION_LABELS[prefs.occasion]);
      if (prefs.loves.length) chips.push('Loves ' + joinAnd(prefs.loves.map(noteName)).toLowerCase());
      if (prefs.avoids.length) chips.push('No ' + joinAnd(prefs.avoids.map(noteName)).toLowerCase());
      E.FACETS.forEach(function (facet) { if (user[facet] < -0.3) chips.push('Less ' + FACET_LABELS[facet].toLowerCase()); });
      if (prefs.intensity !== null && prefs.intensity < 0) chips.push('Light');
      if (prefs.intensity !== null && prefs.intensity > 0) chips.push('Bold');
      if (prefs.lasting) chips.push('Long lasting');
      return chips;
    }

    function whyList(row, index, user) {
      var profile = row.product.profile, why = [];
      if (row.named) why.push('<li style="--dot:#b75c3f">The one you asked for by name</li>');
      if (row.loved.length) {
        why.push('<li style="--dot:#b75c3f">Has the ' + joinAnd(row.loved.map(function (key) { return '<b>' + esc(noteName(key).toLowerCase()) + '</b>'; })) + ' you love</li>');
      }
      var because = E.reasons(row, user, index === 0 ? 3 : 2);
      if (!because.length && !row.loved.length) {
        E.topFacets(profile.vec, 2).forEach(function (facet) {
          var carriers = profile.notes.filter(function (note) { return (note.facets[facet] || 0) >= 0.6; }).slice(0, 3).map(function (note) { return note.name; });
          if (carriers.length) because.push({ facet: facet, notes: carriers });
        });
      }
      because.forEach(function (reason) {
        why.push('<li style="--dot:' + FACET_COLORS[reason.facet] + '"><b>' + FACET_LABELS[reason.facet] + '</b> from ' + esc(joinAnd(reason.notes).toLowerCase()) + '</li>');
      });
      if (prefs.lasting && profile.anchors.length) {
        why.push('<li style="--dot:#2a1a13"><b>Made to stay</b>: a base of ' + esc(joinAnd(profile.anchors.slice(0, 3)).toLowerCase()) + '</li>');
      }
      if (row.avoided.length) {
        why.push('<li style="--dot:#a99a8c">Heads-up: it does contain ' + esc(joinAnd(row.avoided.map(noteName)).toLowerCase()) + '</li>');
      }
      return why.join('');
    }

    function pyramid(profile) {
      return [['Top', 'top'], ['Heart', 'heart'], ['Base', 'base']].map(function (layer) {
        var notes = profile.layers[layer[1]];
        if (!notes.length) return '';
        var text = notes.map(function (raw) {
          var clean = raw;
          var hit = E.lookupNote(clean);
          return hit && prefs.loves.indexOf(hit.key) !== -1 ? '<mark>' + esc(clean) + '</mark>' : esc(clean);
        }).join(', ');
        return '<div class="sf-card__tier sf-card__tier--' + layer[1] + '"><dt>' + layer[0] + '</dt><dd>' + text + '</dd></div>';
      }).join('');
    }

    function overlap(a, b) {
      var both = 0, either = 0, key;
      for (key in a) { either++; if (b[key]) both++; }
      for (key in b) if (!a[key]) either++;
      return either ? both / either : 0;
    }

    function card(row, index, user) {
      if (index > 0) return miniCard(row, index, user);
      var product = row.product, profile = product.profile;
      var url = rootUrl + 'products/' + product.h;
      var family = E.topFacets(profile.vec, 1)[0];
      var gender = product.g === 'men' ? 'For him' : product.g === 'women' ? 'For her' : 'Unisex';
      var price = product.price ? money(product.price) : '';
      var image = product.img ? product.img.replace(/(\.[a-z]+)(\?|$)/i, '$1$2') + (product.img.indexOf('?') === -1 ? '?' : '&') + 'width=' + (index === 0 ? 900 : 600) : '';
      return '<article class="sf-card' + (index === 0 ? ' sf-card--hero' : '') + '" data-sf-card="' + esc(product.h) + '" style="--i:' + index + '">' +
        '<a class="sf-card__media" href="' + esc(url) + '" tabindex="-1" aria-hidden="true">' +
          (image ? '<img src="' + esc(image) + '" alt="" loading="lazy" width="600" height="600">' : '') +
          (index === 0 ? '<span class="sf-card__badge">Best match</span>' : '') +
        '</a>' +
        '<div class="sf-card__body">' +
          '<div class="sf-card__head">' +
            '<div class="sf-card__ring" style="--sf-percent:' + row.percent + '"><b>' + row.percent + '%</b><span>match</span></div>' +
            '<div class="sf-card__names">' +
              '<p class="sf-card__vendor">' + esc(product.vendor || '') + '</p>' +
              '<h3 class="sf-card__title"><a href="' + esc(url) + '">' + esc(product.t) + '</a></h3>' +
              '<p class="sf-card__meta"><span style="--dot:' + FACET_COLORS[family] + '">' + esc(FACET_LABELS[family] || '') + '</span><span>' + gender + '</span></p>' +
            '</div>' +
          '</div>' +
          '<ul class="sf-card__why">' + whyList(row, index, user) + '</ul>' +
          '<dl class="sf-card__pyramid">' + pyramid(profile) + '</dl>' +
          '<div class="sf-card__actions">' +
            '<form is="product-form" method="post" action="' + esc(cartAddUrl) + '" class="sf-card__form" accept-charset="UTF-8" enctype="multipart/form-data">' +
              '<input type="hidden" name="id" value="' + esc(product.variant) + '">' +
              '<input type="hidden" name="quantity" value="1">' +
              '<button type="submit" name="add" class="scent-finder__button sf-card__add"' + (product.avail ? '' : ' disabled') + '>' +
                '<span class="btn__text">' + (product.avail ? 'Add to cart <span class="sf-card__price" data-sf-price>' + price + '</span>' : 'Sold out') + '</span>' +
              '</button>' +
              '<div class="product-form__error-message sf-card__error" hidden></div>' +
            '</form>' +
            '<a class="scent-finder__link sf-card__view" href="' + esc(url) + '">View details</a>' +
          '</div>' +
        '</div>' +
      '</article>';
    }

    // Runners-up: one compact row each, so the best match and both alternatives fit on screen
    function miniCard(row, index, user) {
      var product = row.product, profile = product.profile;
      var url = rootUrl + 'products/' + product.h;
      var family = E.topFacets(profile.vec, 1)[0];
      var gender = product.g === 'men' ? 'For him' : product.g === 'women' ? 'For her' : 'Unisex';
      var image = product.img ? product.img + (product.img.indexOf('?') === -1 ? '?' : '&') + 'width=300' : '';
      var why = '';
      if (row.loved.length) {
        why = 'Has the ' + joinAnd(row.loved.map(function (key) { return '<b>' + esc(noteName(key).toLowerCase()) + '</b>'; })) + ' you love';
      } else {
        var because = E.reasons(row, user, 1)[0];
        if (because) why = '<b>' + FACET_LABELS[because.facet] + '</b> from ' + esc(joinAnd(because.notes).toLowerCase());
      }
      return '<article class="sf-card sf-card--mini" data-sf-card="' + esc(product.h) + '" style="--i:' + index + '">' +
        '<a class="sf-card__media" href="' + esc(url) + '" tabindex="-1" aria-hidden="true">' +
          (image ? '<img src="' + esc(image) + '" alt="" loading="lazy" width="300" height="300">' : '') +
        '</a>' +
        '<div class="sf-card__body">' +
          '<div class="sf-card__head">' +
            '<div class="sf-card__ring" style="--sf-percent:' + row.percent + '"><b>' + row.percent + '%</b></div>' +
            '<div class="sf-card__names">' +
              '<h3 class="sf-card__title"><a href="' + esc(url) + '">' + esc(product.t) + '</a></h3>' +
              '<p class="sf-card__meta"><span style="--dot:' + FACET_COLORS[family] + '">' + esc(FACET_LABELS[family] || '') + '</span><span>' + gender + '</span></p>' +
            '</div>' +
          '</div>' +
          (why ? '<p class="sf-card__line">' + why + '</p>' : '') +
          '<div class="sf-card__actions">' +
            '<form is="product-form" method="post" action="' + esc(cartAddUrl) + '" class="sf-card__form" accept-charset="UTF-8" enctype="multipart/form-data">' +
              '<input type="hidden" name="id" value="' + esc(product.variant) + '">' +
              '<input type="hidden" name="quantity" value="1">' +
              '<button type="submit" name="add" class="scent-finder__button sf-card__add"' + (product.avail ? '' : ' disabled') + '>' +
                '<span class="btn__text">' + (product.avail ? 'Add <span class="sf-card__price" data-sf-price>' + (product.price ? money(product.price) : '') + '</span>' : 'Sold out') + '</span>' +
              '</button>' +
              '<div class="product-form__error-message sf-card__error" hidden></div>' +
            '</form>' +
            '<a class="scent-finder__link sf-card__view" href="' + esc(url) + '">View</a>' +
          '</div>' +
        '</div>' +
      '</article>';
    }

    // Prices in the shopper's own currency, from the product endpoint
    function refreshPrices(rows) {
      rows.forEach(function (row) {
        fetch(rootUrl + 'products/' + row.product.h + '.js', { headers: { Accept: 'application/json' } })
          .then(function (response) { return response.json(); })
          .then(function (json) {
            var variant = (json.variants || []).filter(function (v) { return v.id === row.product.variant; })[0];
            var el = root.querySelector('[data-sf-card="' + row.product.h + '"] [data-sf-price]');
            if (variant && el) el.textContent = money(variant.price);
          }).catch(function () {});
      });
    }

    function renderResults() {
      var result = E.rank(products, prefs);
      // one bottle per scent: skip a perfume whose notes mostly repeat one already shown
      // (another size of it, or its twin under another name)
      var rows = [];
      result.rows.forEach(function (row) {
        if (rows.length >= 5) return; // the best match and four more
        var twin = rows.some(function (kept) { return overlap(kept.product.noteSet, row.product.noteSet) >= 0.8; });
        if (!twin) rows.push(row);
      });
      // Keep the list full when the catalogue has fewer than five distinct scent profiles.
      if (rows.length < 5) {
        result.rows.forEach(function (row) {
          if (rows.length < 5 && !rows.some(function (kept) { return kept.product.h === row.product.h; })) rows.push(row);
        });
      }
      if (!rows.length) return false;

      $('[data-sf-slot="hero"]').innerHTML = card(rows[0], 0, result.user);
      $('[data-sf-slot="runners"]').innerHTML = rows.slice(1).map(function (row, index) { return card(row, index + 1, result.user); }).join('');
      refreshPrices(rows);

      $('[data-sf-results-title]').textContent = 'Meet ' + rows[0].product.t;
      $('[data-sf-read]').innerHTML = readChips(result.user).map(function (chip) { return '<span>' + esc(chip) + '</span>'; }).join('');
      updateStudio(rows[0].product);

      try { sessionStorage.setItem(STORE_KEY, JSON.stringify(prefs)); } catch (error) {}
      root.dispatchEvent(new CustomEvent('scent-finder:result', {
        bubbles: true,
        detail: { preferences: prefs, matches: rows.map(function (row) { return { handle: row.product.h, title: row.product.t, percent: row.percent }; }) }
      }));
      return true;
    }

    // While searching, the perfumes being compared flick past under the lens
    var scanTimer = null;
    function startScan() {
      var scan = $('[data-sf-scan]');
      var index = 0, names = [];
      clearInterval(scanTimer);
      scan.textContent = '';
      if (reduceMotion) return;
      scanTimer = setInterval(function () {
        // the catalogue may still be loading when the search starts, so the list is read on each tick
        if (!names.length && products.length) {
          names = products.map(function (product) { return product.t; });
          for (var k = names.length - 1; k > 0; k--) { var r = Math.floor(Math.random() * (k + 1)), t = names[k]; names[k] = names[r]; names[r] = t; }
        }
        if (!names.length) return;
        index = (index + 1) % names.length;
        scan.classList.remove('is-tick');
        void scan.offsetWidth;
        scan.textContent = names[index];
        scan.classList.add('is-tick');
      }, 140);
    }
    function stopScan() {
      clearInterval(scanTimer);
      scanTimer = null;
    }

    function finish() {
      show('loading');
      $('[data-sf-blend]').textContent = 'Searching the collection';
      startScan();
      var started = Date.now();
      ready.then(function () {
        if (!products.length) { show('intro'); return; }
        $('[data-sf-blend]').textContent = 'Searching ' + products.length + ' perfumes for your scent';
        var wait = Math.max(0, (reduceMotion ? 200 : 1800) - (Date.now() - started));
        timer = setTimeout(function () {
          if (renderResults()) show('results');
          else show('intro');
        }, wait);
      });
    }

    function ask() {
      var text = textarea.value.trim();
      errorEl.hidden = true;
      if (!text) { textarea.focus(); return; }
      ready.then(function () {
        var read = E.readText(text);
        var asked = E.named(products, text);
        if (!read.hits && !asked.loves.length && !asked.avoids.length) {
          errorEl.textContent = 'I couldn’t pick a scent out of that. Try words like fresh, sweet or woody, a note like oud or vanilla, an occasion like date night, or one of our perfume names — or take the quiz below.';
          errorEl.hidden = false;
          return;
        }
        // "Something like Legend": the named perfume's own accords join the taste, so the runners-up resemble it
        asked.loves.forEach(function (handle) {
          var match = products.filter(function (product) { return product.h === handle; })[0];
          if (match) E.FACETS.forEach(function (facet) { read.vec[facet] += match.profile.vec[facet] * 0.8; });
        });
        prefs = blankPrefs();
        prefs.text = text;
        prefs.textVec = read.vec;
        prefs.gender = read.gender;
        prefs.occasion = read.occasion;
        prefs.loves = read.loves;
        prefs.avoids = read.avoids;
        prefs.named = asked.loves;
        prefs.namedAvoid = asked.avoids;
        prefs.intensity = read.intensity ? read.intensity : null;
        prefs.lasting = read.lasting;
        syncChoices();
        updateStudio();
        finish();
      });
    }

    function reset() {
      prefs = blankPrefs();
      textarea.value = '';
      errorEl.hidden = true;
      try { sessionStorage.removeItem(STORE_KEY); } catch (error) {}
      $('[data-sf-slot="hero"]').innerHTML = '';
      $('[data-sf-slot="runners"]').innerHTML = '';
      syncChoices();
      updateStudio();
      show('intro');
    }

    function restore() {
      var saved = null;
      try { saved = JSON.parse(sessionStorage.getItem(STORE_KEY)); } catch (error) { saved = null; }
      if (saved && products.length && Array.isArray(saved.vibes) && Array.isArray(saved.loves) && Array.isArray(saved.avoids) && current === 'intro') {
        prefs = Object.assign(blankPrefs(), saved);
        textarea.value = prefs.text || '';
        syncChoices();
        if (renderResults()) show('results', true);
        else { prefs = blankPrefs(); syncChoices(); updateStudio(); }
      }
    }

    /* ----- Events ----- */
    root.addEventListener('click', function (event) {
      var target = event.target.closest('[data-sf-choice], [data-sf-note], [data-sf-next], [data-sf-back], [data-sf-start], [data-sf-example], [data-sf-tune], [data-sf-reset]');
      if (!target || !root.contains(target)) return;

      if (target.hasAttribute('data-sf-choice')) {
        var key = target.getAttribute('data-sf-choice'), value = target.getAttribute('data-value');
        if (key === 'vibes') {
          var at = prefs.vibes.indexOf(value);
          if (at !== -1) prefs.vibes.splice(at, 1);
          else { prefs.vibes.push(value); if (prefs.vibes.length > 2) prefs.vibes.shift(); }
        } else if (key === 'gender') prefs.gender = value;
        else if (key === 'occasion') prefs.occasion = value || null;
        else if (key === 'intensity') prefs.intensity = parseFloat(value);
        syncChoices();
        if (key === 'occasion' && !value) target.setAttribute('aria-pressed', 'true');
        updateStudio();
        if (key !== 'vibes') advanceSoon();
      } else if (target.hasAttribute('data-sf-note')) {
        var note = target.getAttribute('data-sf-note');
        var loved = prefs.loves.indexOf(note), avoided = prefs.avoids.indexOf(note);
        if (loved !== -1) { prefs.loves.splice(loved, 1); prefs.avoids.push(note); }
        else if (avoided !== -1) prefs.avoids.splice(avoided, 1);
        else prefs.loves.push(note);
        syncChoices();
        updateStudio();
      } else if (target.hasAttribute('data-sf-next')) {
        advance();
      } else if (target.hasAttribute('data-sf-back')) {
        var step = STEPS.indexOf(current);
        show(step > 0 ? STEPS[step - 1] : 'intro');
      } else if (target.hasAttribute('data-sf-start') || target.hasAttribute('data-sf-tune')) {
        if (target.hasAttribute('data-sf-start')) { prefs = blankPrefs(); syncChoices(); }
        updateStudio();
        show('who');
      } else if (target.hasAttribute('data-sf-example')) {
        textarea.value = target.textContent.trim();
        ask();
      } else if (target.hasAttribute('data-sf-reset')) {
        reset();
      }
    });

    $('[data-sf-ask]').addEventListener('submit', function (event) { event.preventDefault(); ask(); });
    textarea.addEventListener('keydown', function (event) {
      if (event.key === 'Enter' && !event.shiftKey) { event.preventDefault(); ask(); }
    });
    textarea.addEventListener('input', function () { errorEl.hidden = true; });

    syncChoices();
    updateStudio();
  }

  function boot(scope) {
    Array.prototype.forEach.call(scope.querySelectorAll('[data-scent-finder]'), init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(document); });
  else boot(document);
  document.addEventListener('shopify:section:load', function (event) { boot(event.target); });
})();
